import { render, staticRenderFns } from "./dil_spklu.vue?vue&type=template&id=f949949e&scoped=true&"
import script from "./dil_spklu.vue?vue&type=script&lang=js&"
export * from "./dil_spklu.vue?vue&type=script&lang=js&"
import style0 from "./dil_spklu.vue?vue&type=style&index=0&id=f949949e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f949949e",
  null
  
)

export default component.exports